import type { TAbTestKey } from 'constants/ab-tests'
import { getFilteredCohortAbTestKeys } from 'helpers/getFilteredCohortAbTestKeys'
import type { TRemoteConfigVariantData } from 'helpers/getRemoteConfigVariantData'
import { type Cohort } from 'root-constants'

export type TAbTestAnalyticsEntry = {
  key: TAbTestKey
  value: string
}

export const getAbTestAnalyticsEntries = ({
  cohort,
  country,
  remoteConfigVariantData,
}: {
  cohort: Cohort | string
  country?: string
  remoteConfigVariantData: TRemoteConfigVariantData | null
}): TAbTestAnalyticsEntry[] => {
  if (!remoteConfigVariantData) {
    return []
  }

  return getFilteredCohortAbTestKeys(cohort, country)
    .map((key) => ({ key, variantData: remoteConfigVariantData[key] }))
    .filter(
      ({ variantData }) => variantData?.sendAnalytics && variantData.value,
    )
    .map(({ key, variantData }) => ({ key, value: variantData.value }))
}
